import { useMemo } from 'react';
import { PERMISSIONS } from '@moleculeone/auth';
import { keyBy } from 'lodash';

import { useCheckPermissions } from './useCheckPermissions';

export type MenuElementType = {
  tabId: string;
  title: string;
  path?: string;
  permissions?: string[];
};

const ELEMENTS: MenuElementType[] = [
  {
    tabId: 'synthesis-plans',
    title: 'Searches',
    path: '/dashboard/batch',
    permissions: [PERMISSIONS.RETRO.APP.READ],
  },
  {
    tabId: 'starting-materials',
    title: 'Starting materials',
    path: '/dashboard/starting-materials',
    permissions: [PERMISSIONS.RETRO.APP.READ],
  },
  {
    tabId: 'reports',
    title: 'Reports',
    permissions: [PERMISSIONS.RETRO.APP.READ],
    path: '/dashboard/reports',
  },
];

function validate(elements: MenuElementType[] = [], checkPermissions: (permissions: string[]) => boolean) {
  return elements.flatMap(element => (checkPermissions(element.permissions ?? []) ? [element] : []));
}

export function useNavigationMenuElements(): { [key: string]: MenuElementType } {
  const checkPermissions = useCheckPermissions();

  return useMemo(() => keyBy(validate(ELEMENTS, checkPermissions), 'tabId'), []);
}
